import script from "./side.vue?vue&type=script&setup=true&lang=ts"
export * from "./side.vue?vue&type=script&setup=true&lang=ts"

import "./side.vue?vue&type=style&index=0&id=6eece210&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eece210"]])

export default __exports__